import { Reducer } from 'redux';
import IAppsAndSolutionsState from '../state/AppsAndSolutionsState';
import {
  AppsAndSolutionsAction,
  AppsAndSolutionsActionTypes,
} from '../actions/AppsAndSolutionsActions';
import {
  IAvailableApplication,
  IEnvironment,
  IWorkloadPattern,
} from '../../models/AppsAndSolutionsModels';

export const initialState: IAppsAndSolutionsState = {
  environments: [],
  workloadPatterns: [],
  availableApplications: [],
  error: undefined,
  loading: false,
  loadingCount: 0,
};

export const appsAndSolutionsReducer: Reducer<IAppsAndSolutionsState> = (
  state = initialState,
  action: AppsAndSolutionsAction,
) => {
  switch (action.type) {
    case AppsAndSolutionsActionTypes.GET_ENVIRONMENTS_START:
    case AppsAndSolutionsActionTypes.GET_WORKLOAD_PATTERNS_START:
    case AppsAndSolutionsActionTypes.GET_AVAILABLE_APPLICATIONS_START:
    case AppsAndSolutionsActionTypes.DEPLOY_APPLICATION_START:
    case AppsAndSolutionsActionTypes.CREATE_WORKLOAD_PATTERN_START:
      return {
        ...state,
        loading: true,
        loadingCount: state.loadingCount + 1,
      };

    case AppsAndSolutionsActionTypes.GET_ENVIRONMENTS_SUCCESS: {
      return {
        ...state,
        environments: action.data as IEnvironment[],
        error: undefined,
        loading: false,
        loadingCount: state.loadingCount - 1,
      };
    }
    case AppsAndSolutionsActionTypes.GET_WORKLOAD_PATTERNS_SUCCESS: {
      return {
        ...state,
        workloadPatterns: action.data as IWorkloadPattern[],
        error: undefined,
        loading: false,
        loadingCount: state.loadingCount - 1,
      };
    }
    case AppsAndSolutionsActionTypes.GET_AVAILABLE_APPLICATIONS_SUCCESS: {
      return {
        ...state,
        availableApplications: action.data as IAvailableApplication[],
        error: undefined,
        loading: false,
        loadingCount: state.loadingCount - 1,
      };
    }
    case AppsAndSolutionsActionTypes.DEPLOY_APPLICATION_SUCCESS:
    case AppsAndSolutionsActionTypes.CREATE_WORKLOAD_PATTERN_SUCCESS: {
      return {
        ...state,
        error: undefined,
        loading: false,
        loadingCount: state.loadingCount - 1,
      };
    }
    case AppsAndSolutionsActionTypes.GET_ENVIRONMENTS_ERROR:
    case AppsAndSolutionsActionTypes.GET_WORKLOAD_PATTERNS_ERROR:
    case AppsAndSolutionsActionTypes.GET_AVAILABLE_APPLICATIONS_ERROR:
    case AppsAndSolutionsActionTypes.DEPLOY_APPLICATION_ERROR:
    case AppsAndSolutionsActionTypes.CREATE_WORKLOAD_PATTERN_ERROR:
      return {
        ...state,
        error: action.data,
        loading: false,
        loadingCount: state.loadingCount - 1,
      };
    case AppsAndSolutionsActionTypes.APPS_AND_SOLN_HARD_RELOAD:
      return {
        ...state,
        loading: false,
        loadingCount: 0,
      };

    default:
      return state;
  }
};
